import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { Store } from "@ngrx/store";
import { ShelterAppStateModel } from "../../../../petszel-shelter/src/app/store/ShelterAppStateModel";
import {
  setPermissions
} from "../../../../petszel-shelter/src/app/store/user/permissions/permissions.actions";
import { jwtDecode } from "jwt-decode";

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  isLoggedInObs$: Observable<boolean>;
  private isLoggedIn$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(private store: Store<ShelterAppStateModel>) {
    this.isLoggedInObs$ = this.isLoggedIn$.asObservable();
  }

  setLogInStatus(isLoggedIn: boolean): void {
    this.isLoggedIn$.next(isLoggedIn);
  }

  getLatestIsLoggedInValue(): boolean {
    return this.isLoggedIn$.getValue();
  }

  setUserPermissions(): void {
    const token = localStorage.getItem('token');
    let permissions: string[] = [];

    if (token) {
      const decodedToken = jwtDecode(token) as any;
      permissions = decodedToken['http://schemas.microsoft.com/identity/claims/scope'] || [];
    }

    this.store.dispatch(setPermissions({ permissions }));
  }
}
